<template>
  <div class="flex flex-row my-2 w-fit ml-auto">
    <div v-if="info" v-tooltip.top="info" class="rounded-full bg-info-500 h-5 w-5 my-auto flex items-center justify-center">
      <i class="pi pi-question-circle text-surface-50"></i>
    </div>
    <label class="font-bold my-auto mx-3" :class="required ? 'required' : ''">{{ label }}:</label>
    <div class="flex flex-row gap-3">
      <InputNumber
        v-if="tab != null"
        v-model="tab"
        showButtons
        increment-button-class="py-0! w-full"
        decrement-button-class="py-0! w-full"
        :min="0"
        :disabled="disableTab"
        class="h-9"
        inputClass="w-16"
        :allowEmpty="false"
        pt:buttonGroup:class="w-6!"
      ></InputNumber>
      <Select v-model="column" :options="columns" class="h-9 w-20" :class="size" inputClass="uppercase px-2! text-center self-center"></Select>
      <InputNumber
        v-if="row != null"
        v-model="row"
        showButtons
        increment-button-class="py-0! w-full"
        decrement-button-class="py-0! w-full"
        :min="1"
        class="h-9"
        inputClass="w-16 pe-0"
        :allowEmpty="false"
        pt:buttonGroup:class="w-6!"
      ></InputNumber>
    </div>
  </div>
</template>

<script setup lang="ts">
const tab = defineModel<number>("tab");
const column = defineModel<string>("column", { required: true });
const row = defineModel<number>("row");

interface Props {
  label: string;
  columns: string[];
  size?: string;
  info?: string;
  required?: boolean;
  disableTab?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  size: "w-18",
  required: false,
  disableTab: false,
});
</script>
